import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material/material.module';
import { AccionesCampanaVentaComponent, DialogAccionesCrearLanding, DialogAccionesCrearCampaniaVenta, DialogAccionesEditarCampaniaVenta, DialogAccionesEditarLanding, DialogDetalleLanding, } from './acciones-campana-venta.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LandingService } from '../../../providers/landing.service';
import { ImageUploadModule } from '../../archivos/image-upload.module';
import { GeneralService } from '../../../providers/general.service';
import { PipesModule } from '../../../pipes/pipes.module';
import { ConfiguracionEmpresaService } from '../../../providers/configuracion-empresa.service';
import { PropuestasService } from '../../../providers/propuestas.service';
import { ZapierModule } from '../zapier/zapier.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    FormsModule,
    PipesModule,
    ImageUploadModule.forRoot(),
    ZapierModule,
    RouterModule
  ],
  declarations:
    [
      AccionesCampanaVentaComponent,
      DialogAccionesCrearLanding,
      DialogAccionesCrearCampaniaVenta,
      DialogAccionesEditarCampaniaVenta,
      DialogAccionesEditarLanding,
      DialogDetalleLanding
    ],
  entryComponents:
    [
      AccionesCampanaVentaComponent,
      DialogAccionesCrearLanding,
      DialogAccionesCrearCampaniaVenta,
      DialogAccionesEditarCampaniaVenta,
      DialogAccionesEditarLanding,
      DialogDetalleLanding
    ],
  exports:
    [
      AccionesCampanaVentaComponent,
      DialogAccionesCrearLanding,
      DialogAccionesCrearCampaniaVenta,
      DialogAccionesEditarCampaniaVenta,
      DialogAccionesEditarLanding,
      DialogDetalleLanding
    ],
  providers: [
  ],
})
export class AccionesCampanaVentaModule { }
